import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getMessaging, isSupported as isMessagingSupported } from 'firebase/messaging'
import { firebaseConfig } from './firebaseConfig'

export { firebaseConfig }

function hasRequiredConfig() {
  return Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.authDomain &&
      firebaseConfig.projectId
  )
}

const app = hasRequiredConfig() ? initializeApp(firebaseConfig) : null

export const auth = app ? getAuth(app) : null

/** Lazily resolves a Messaging instance, or null if unsupported/unconfigured (e.g. Safari without a VAPID key, SSR). */
let _messagingPromise = null
export function getMessagingInstance() {
  if (!app) return Promise.resolve(null)
  if (!_messagingPromise) {
    _messagingPromise = isMessagingSupported().then((supported) =>
      supported ? getMessaging(app) : null
    )
  }
  return _messagingPromise
}

export function getGoogleProvider() {
  return new GoogleAuthProvider()
}

export function isFirebaseAuthConfigured() {
  return auth != null
}

/** Human-readable hint when Google sign-in is disabled (empty env after Vite load). */
export function getFirebaseAuthConfigHint() {
  const missing = []
  if (!firebaseConfig.apiKey) missing.push('VITE_FIREBASE_API_KEY')
  if (!firebaseConfig.authDomain) missing.push('VITE_FIREBASE_AUTH_DOMAIN')
  if (!firebaseConfig.projectId) missing.push('VITE_FIREBASE_PROJECT_ID')
  if (missing.length === 0) return ''
  return `Set ${missing.join(', ')} in frontend/.env (Firebase Console → Project settings → your Web app → firebaseConfig). Then restart the dev server.`
}
